module.exports = __webpack_public_path__ + "static/media/30-hrverk.a8df4f92.mp3";